import { assertWriteIdentity, captureWriteIdentity, type WriteIdentity } from './http'

const pending = new Map<string, Set<Promise<unknown>>>()

export function trackSettingsWrite<T>(work: (identity: WriteIdentity) => Promise<T>): Promise<T> {
  const identity = captureWriteIdentity()
  const key = JSON.stringify(identity)
  const writes = pending.get(key) ?? new Set<Promise<unknown>>()
  pending.set(key, writes)
  const result = (async () => {
    const value = await work(identity)
    assertWriteIdentity(identity)
    return value
  })()
  writes.add(result)
  const settled = () => {
    writes.delete(result)
    if (writes.size === 0) pending.delete(key)
  }
  void result.then(settled, settled)
  return result
}

export async function waitForSettingsWrites(): Promise<void> {
  const identity = captureWriteIdentity()
  const key = JSON.stringify(identity)
  for (;;) {
    assertWriteIdentity(identity)
    const writes = pending.get(key)
    if (!writes?.size) return
    const results = await Promise.allSettled([...writes])
    assertWriteIdentity(identity)
    const failure = results.find((result) => result.status === 'rejected')
    if (failure?.status === 'rejected') throw failure.reason
  }
}
